<template>
  <div class="detail-dialog">
    <div class="detail-dialog-header">
      <div class="detail-dialog-header-title">
        {{ title }}
      </div>
      <div class="detail-dialog-header-button">
        <v-btn
          small
          outlined
          color="primary"
          :disabled="isLoading"
          @click.stop="onRefresh"
        >
          <v-icon
            small
          >
            mdi-refresh
          </v-icon>
          초기화
        </v-btn>
        <div class="custom-spacer" />
        <v-btn
          small
          outlined
          color="primary"
          :disabled="isLoading"
          @click.stop="onSaveUsage"
        >
          <v-icon
            small
          >
            mdi-content-save-outline
          </v-icon>
          저장
        </v-btn>
        <div class="custom-spacer" />
        <v-btn
          small
          outlined
          color="primary"
          :disabled="isLoading"
          @click.stop="onClickCreateBilling"
        >
          <v-icon
            small
          >
            mdi-currency-krw
          </v-icon>
          매출 생성
        </v-btn>
        <div class="custom-spacer" />
        <v-btn
          small
          outlined
          color="red"
          :disabled="isLoading"
          @click.stop="onCloseThis"
        >
          <v-icon
            small
          >
            mdi-close-box-outline
          </v-icon>
          닫기
        </v-btn>
      </div>
    </div>
    <div class="custom-spacer" />
    <div class="detail-dialog-body">
      <div class="sub-container">
        <div class="sub-title">
          기본정보
        </div>
        <div class="sub-content-wrap">
          <div class="sub-content-item one-fourth">
            요금제:
            <select :value="editContext.rentalcompanyPlanId" @change="e => onChangeRcPlanId(e)">
              <option :value="null" disabled>
                선택 안함
              </option>
              <option
                v-for="rcPlanItem in rcPlanList"
                :key="`base-plan-${rcPlanItem.rentalcompanyPlanId}`"
                :value="String(rcPlanItem.rentalcompanyPlanId)"
              >
                {{ `${rcPlanItem.planName} (${rcPlanItem.useYn === 'Y' ? '사용중' : '사용안함'})` }}
              </option>
            </select>
          </div>
          <div class="sub-content-item one-fourth">
            정산월:
            <input
              v-model="computedSalesMonth"
              type="month"
              max="2099-12"
              min="2020-01"
              pattern="\d{4}-\d{2}"
            >
          </div>
          <div class="sub-content-item one-fourth">
            사용기간 시작일:
            <input
              v-model="editContext.startDate"
              type="date"
              max="2099-12-31"
              min="2020-01-01"
              pattern="\d{4}-\d{2}-\d{2}"
            >
          </div>
          <div class="sub-content-item one-fourth">
            사용기간 종료일:
            <input
              v-model="editContext.endDate"
              type="date"
              max="2099-12-31"
              min="2020-01-01"
              pattern="\d{4}-\d{2}-\d{2}"
            >
          </div>
        </div>
      </div>
      <div class="custom-spacer" />

      <div class="sub-container">
        <div class="sub-content-wrap">
          <div class="sub-content-item one-fourth" />
          <div class="sub-content-item one-fourth">
            실 사용 일: {{ editContext.usageDays }} 일
          </div>
          <div class="sub-content-item one-fourth">
            사용월 일수: {{ usageMonthDays }} 일
          </div>
          <div class="sub-content-item one-fourth">
            일할계산(%): {{ dailyCalc }} %
            <v-btn
              small
              outlined
              color="primary"
              class="ml-2"
              @click.stop="onClickDailyCalcApplication"
            >
              적용
            </v-btn>
          </div>
        </div>
      </div>
      <div class="custom-spacer" />
      <div class="sub-container">
        <div class="sub-title">
          청구내용
        </div>
        <div v-if="editContext && usageRcPlan" class="sub-content-wrap">
          <table>
            <thead>
            <tr>
              <th width="230px" colspan="2">
                구분
              </th>
              <th colspan="3" class="border-right-thick">
                설정 요금제
              </th>
              <th colspan="2">
                청구서
              </th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <th colspan="2" width="230px">
                기본료
              </th>
              <td colspan="3" class="border-right-thick">
                {{ Number(usageRcPlan.baseFee || 0).toLocaleString() }} 원
              </td>
              <td colspan="2">
                <input
                  v-model="editContext.baseFee"
                  type="number"
                  max="99999999"
                  min="0"
                > 원
              </td>
            </tr>
            <tr v-for="(supplyItem, idx ) in convertSupplyServiceSubPlan" :key="`supply-item-${supplyItem.itemId}`">
              <th v-if="idx === 0" width="30px" :rowspan="convertSupplyServiceSubPlan.length" class="write-vertical-lr">
                부가 서비스
              </th>
              <th width="200px">
                {{ supplyItem.itemName }}
              </th>
              <td colspan="2">
                이용료:
                {{ Number(supplyItem.addFee || 0).toLocaleString() }} 원
              </td>
              <td width="200px" class="border-right-thick">
                보류 기한:
                <template v-if="supplyItem.holdDatetime">
                  {{ $parseDate(supplyItem.holdDatetime).toFormat('yyyy-MM-dd') }} 까지
                </template>
                <template v-else>
                  없음
                </template>
              </td>
              <td colspan="2">
                <!--                v-model="editContext.mpsUsageItems.find(
                                e => e.rentalcompanyPlanItemId === supplyItem.itemId
                                ).addFee"-->
                <input
                  v-model="supplyItem.editItem.addFee"
                  type="number"
                  max="99999999"
                  min="0"
                  @keyup="calcTotalFee"
                > 원
              </td>
            </tr>
            <tr v-for="(subItem, idx) in convertSubPlan" :key="'sub-item-' + subItem.codeKey">
              <th v-if="idx === 0" width="30px" :rowspan="convertSubPlan.length" class="write-vertical-lr">
                추가 사용
              </th>
              <th width="200px">
                {{ subItem.codeValue }}
              </th>
              <td>
                기본제공: {{ Number(subItem.planItem.standardCnt || 0) }} 개
              </td>
              <td>
                추가료: {{ subItem.planItem.addCnt }} 개 당 {{ subItem.planItem.addFee }} 원
              </td>
              <td class="border-right-thick">
                보류 기한:
                <template v-if="subItem.planItem.holdDatetime">
                  {{ $parseDate(subItem.planItem.holdDatetime).toFormat('yyyy-MM-dd') }} 까지
                </template>
                <template v-else>
                  없음
                </template>
              </td>
              <td>
                사용량:
                <input
                  v-if="!!subItem.editItem"
                  v-model="subItem.editItem.usageCnt"
                  type="number"
                  max="99999999"
                  min="0"
                  @keyup="changeUsageSubItems(100)"
                > 개
              </td>
              <td>
                {{
                  Number(subItem.editItem.addFee || 0).toLocaleString()
                }} 원
              </td>
            </tr>
            <tr>
              <th colspan="2">
                계
              </th>
              <td colspan="5">
                {{
                  `기본료: ${editContext.baseFee.toLocaleString()} 원
                + 추가료: ${editContext.sumAddFee.toLocaleString()} 원
                = ${editContext.totalFee.toLocaleString()} 원`
                }}
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="custom-spacer" />
      <div class="sub-container">
        <div class="sub-title">
          <!--          비고-->
        </div>
        <div class="sub-content-wrap">
          <!--          <textarea
                      v-model="editContext"
                    />-->
        </div>
      </div>
    </div>
    <div class="custom-spacer" />
    <div class="detail-dialog-footer" />
  </div>
</template>

<script>
import time from "../../assets/plugins/mps-common/time";
import {PATH} from "../../constants";
import {cloneDeep} from "lodash";

export default {
  name: "MpsUsageDetail",
  props: {
    item: {
      type: Object,
      default: undefined
    },

    basePlanList: {
      type: Array,
      default: () => []
    },
    subItemCodes: {
      type: Array,
      default: () => []
    },
  },
  data() {
    return {
      editContext: {
        accountId: undefined,
        baseFee: undefined,
        endDate: undefined,
        mpsUsageId: undefined,
        mpsUsageItems: [],
        mpsUsageItemsJson: undefined,
        regDatetime: undefined,
        register: undefined,
        registerName: undefined,
        remark: undefined,
        rentalcompanyId: undefined,
        rentalcompanyName: undefined,
        rentalcompanyPlanId: undefined,
        salesMonth: undefined,
        startDate: undefined,
        sumAddFee: undefined,
        totalFee: undefined,
        usageDays: undefined,
        usageMonth: undefined,
        useYn: undefined,
      },
      rcPlanList: [],
      isLoading: false,
    }
  },
  computed: {
    title() {
      if (!this.item)
        return '청구서 상세'

      const {rentalcompanyId, rentalcompanyName, ...others} = this.item

      return `청구서 상세 - ${rentalcompanyName} (${rentalcompanyId}) `
    },

    computedSalesMonth: {
      get() {
        if (!this.editContext || !this.editContext.salesMonth)
          return undefined
        try {
          const parseDate = this.$parseDate(this.editContext.salesMonth)
          return parseDate.toFormat('yyyy-MM')
        } catch (e) {
          return undefined
        }
      },
      set(newVal) {
        if (!newVal || newVal === '')
          return this.editContext.salesMonth = undefined
        this.editContext.salesMonth = newVal + '-01'
      },
    },
    /**
     * 해당 청구서의 사용된 임대업체 요금제 정보
     * @return {undefined|*}
     */
    usageRcPlan() {
      if (!this.editContext || !this.editContext.rentalcompanyPlanId)
        return undefined
      return this.rcPlanList.find(e => e.rentalcompanyPlanId === this.item.rentalcompanyPlanId)
    },

    /**
     * 해당 청구서의 사용된 기본 요금제 정보
     * @return {undefined|*}
     */
    usageBasePlan() {
      if (!this.usageRcPlan || !this.usageRcPlan.planId)
        return undefined
      return this.basePlanList.find(e => e.planId === this.usageRcPlan.planId)
    },


    /**
     * 부가서비스
     * @return {T[]|*[]}
     */
    convertSupplyServiceSubPlan() {
      if (!this.usageRcPlan)
        return []
      const result = this.usageRcPlan.planItems.filter(e => e.itemType === 'B' && e.deleteYn != 'Y')
      result.forEach(e => {
        const findItem = this.editContext.mpsUsageItems.find(t => t.rentalcompanyPlanItemId === e.itemId)
        e.editItem = findItem
      })
      return result
    },

    /**
     * 추가사용료
     * @return {unknown[]|*[]}
     */
    convertSubPlan() {
      if (!this.usageRcPlan || this.subItemCodes.length <= 0)
        return []

      const result = this.subItemCodes.map(e => {
        let planItem = this.usageRcPlan.planItems.find(t => t.codeKey === e.codeKey)
        if (!planItem) {
          return {
            ...e,
            planItem: {
              itemType: 'A',
              standardCnt: 0,
              addCnt: 0,
              addFee: 0.0,
            },
            editItem: {
              addFee: 0.0,
              usageCnt: 0
            }
          }
        } else {
          const editItem = this.editContext.mpsUsageItems.find(
            t => t.rentalcompanyPlanItemId === planItem.itemId
          )
          return {
            ...e,
            planItem,
            editItem,
          }
        }
      })
      return result
    },

    usageMonthDays () {
      if (!this.editContext.usageMonth)
        return undefined

      try {
        return this.$parseDate(this.editContext.usageMonth).daysInMonth
      } catch (e) {
        return undefined
      }
    },

    dailyCalc() {
      if (!this.editContext.usageDays || !this.usageMonthDays)
        return undefined

      try {
        return Math.floor(this.editContext.usageDays / this.usageMonthDays * 100)
      } catch (e) {
        return undefined
      }
    },

  },
  watch: {
    item: {
      immediate: true,
      deep: true,
      async handler(newVal) {
        await this.loadRcPlanList()
        this.initData()
      }
    },
    'editContext.baseFee': {
      immediate: false,
      deep: true,
      handler(newVal) {
        this.editContext.baseFee = Number(newVal || 0)
        this.calcTotalFee()
      }
    },
    'editContext.startDate':{
      immediate: false,
      deep: true,
      handler(newVal) {
        this.changeUsageDate()
      }
    },
    'editContext.endDate':{
      immediate: true,
      deep: true,
      handler(newVal) {
        this.changeUsageDate()
      }
    },

    'editContext.rentalcompanyPlanId': {
      immediate: false,
      deep: true,
      handler(newVal) {
        console.log('HSTEST:: rentalcompanyPlanId ', newVal)
      }
    },
  },

  destroyed() {
    this.editContext.accountId = undefined
    this.editContext.baseFee = undefined
    this.editContext.endDate = undefined
    this.editContext.mpsUsageId = undefined
    this.editContext.mpsUsageItems.splice(0, this.editContext.mpsUsageItems.length)
    this.editContext.mpsUsageItemsJson = undefined
    this.editContext.regDatetime = undefined
    this.editContext.register = undefined
    this.editContext.registerName = undefined
    this.editContext.remark = undefined
    this.editContext.rentalcompanyId = undefined
    this.editContext.rentalcompanyName = undefined
    this.editContext.rentalcompanyPlanId = undefined
    this.editContext.salesMonth = undefined
    this.editContext.startDate = undefined
    this.editContext.sumAddFee = undefined
    this.editContext.totalFee = undefined
    this.editContext.usageDays = undefined
    this.editContext.usageMonth = undefined
    this.editContext.useYn = undefined
    this.rcPlanList.splice(0, this.rcPlanList.length)
  },

  methods: {
    /**
     * 초기화
     */
    initData (){
      const cloneTemp = cloneDeep(this.item)
      this.editContext.accountId = cloneTemp.accountId
      this.editContext.rentalcompanyId = cloneTemp.rentalcompanyId
      this.editContext.rentalcompanyName = cloneTemp.rentalcompanyName

      this.editContext.baseFee = cloneTemp.baseFee || 0
      this.editContext.mpsUsageId = cloneTemp.mpsUsageId
      this.editContext.mpsUsageItemsJson = cloneTemp.mpsUsageItemsJson
      this.editContext.remark = cloneTemp.remark
      this.editContext.rentalcompanyPlanId = cloneTemp.rentalcompanyPlanId

      this.editContext.salesMonth = cloneTemp.salesMonth
      this.editContext.startDate = cloneTemp.startDate
      this.editContext.endDate = cloneTemp.endDate
      this.editContext.usageDays = cloneTemp.usageDays
      this.editContext.usageMonth = cloneTemp.usageMonth

      this.editContext.sumAddFee = cloneTemp.sumAddFee
      this.editContext.totalFee = cloneTemp.totalFee
      this.editContext.useYn = cloneTemp.useYn

      this.editContext.mpsUsageItems.splice(0, this.editContext.mpsUsageItems.length)
      if (!!cloneTemp.mpsUsageItems && cloneTemp.mpsUsageItems.length > 0)
        this.editContext.mpsUsageItems.push(...cloneTemp.mpsUsageItems)

      this.setEditContextEmptySubItem()
    },

    /**
     * 임대업체 설정 요금제 불러오기
     * @return {Promise<void>}
     */
    async loadRcPlanList() {
      try {
        const res = await this.$request(PATH.MPS_PLAN.RENTALCOMPANY_PLAN)
          .setObject({
            rentalcompanyId: this.item.rentalcompanyId
          })
          .catch(e => {
          })
          .enqueue()
        if (!res || res === '' || !res.data || res.data.length <= 0) {
          this.$toasted.error('임대업체의 설정된 요금제 정보가 없습니다.')
          return
        }

        this.rcPlanList.splice(0, this.rcPlanList.length)
        this.rcPlanList.push(...res.data)
      } catch (e) {
        console.error(e)
        this.$toasted.error('청구서의 기반 데이터 정보가 올바르지 않습니다.')
      }
    },

    /**
     * 빈 아이템 추가
     */
    setEditContextEmptySubItem() {
      this.editContext.planName = this.usageRcPlan.planName
      this.usageRcPlan.planItems.forEach(e => {
        const findSubItem = this.editContext.mpsUsageItems.find(
          t => Number(t.rentalcompanyPlanItemId) === Number(e.itemId)
        )
        if (!findSubItem) {
          this.editContext.mpsUsageItems.push(
            {
              itemName: e.itemName,
              itemId: undefined,
              addFee: 0,
              mpsUsageId: undefined,
              rentalcompanyPlanItemId: e.itemId,
              usageCnt: 0,
              itemType: e.itemType,
            }
          )
        } else {
          findSubItem.itemName = e.itemName
          findSubItem.itemType = e.itemType
        }
      })
    },

    /**
     * 사용 날짜 변경 시 사용일수 체크
     */
    changeUsageDate() {
      if (!this.editContext.startDate || !this.editContext.endDate)
        return
      let pStartDate = this.$parseDate(this.editContext.startDate)
      let pEndDate = this.$parseDate(this.editContext.endDate)
      if(pEndDate.diff(pStartDate, 'days').toObject().days < 0 ){
        this.$toasted.error('사용기간 시작일과 종료일이 유효하지 않아 보정하였습니다.')
        pEndDate = pStartDate.plus({ days: 1 })
        this.editContext.endDate = pEndDate.toFormat('yyyy-MM-dd')
      }

      this.editContext.usageMonth = pStartDate.toFormat('yyyy-MM-01')
      this.editContext.usageDays = pEndDate.diff(pStartDate, 'days').toObject().days + 1
    },

    /**
     * 하위(부가서비스, 추가사용료) 정보가 바뀜
     * @param dc: 일할계산 %
     */
    changeUsageSubItems(dc = 100) {
      this.editContext.sumAddFee = 0
      this.editContext.mpsUsageItems.forEach(e => {
        e.usageCnt = Number(e.usageCnt || 0)
        e.addFee = Number(e.addFee || 0)
        const findPlanItem = this.usageRcPlan.planItems.find(t => t.itemId === e.rentalcompanyPlanItemId)

        const parsHoldDate = !!findPlanItem && !!findPlanItem.holdDatetime ? this.$parseDate(findPlanItem.holdDatetime).startOf('month') : undefined
        const parsUsageMonth = this.$parseDate(this.editContext.usageMonth).startOf('month')

        if (!!findPlanItem && findPlanItem.itemType === 'B') {
          e.addFee = Math.floor( Number(e.addFee || 0) * dc / 100 )
        } else if ( (!!parsHoldDate && parsHoldDate.diff(parsUsageMonth).toObject().milliseconds >= 0) || !e.usageCnt || !findPlanItem.addCnt || !findPlanItem.addFee || (e.usageCnt - findPlanItem.standardCnt) <= 0) {
          e.addFee = 0
        } else {
          e.addFee = Math.floor( Math.floor((e.usageCnt - findPlanItem.standardCnt) / findPlanItem.addCnt) * findPlanItem.addFee * dc / 100  )
        }
      })
      this.calcTotalFee()
    },

    /**
     * 일할계산 적용 버튼 클릭
     */
    onClickDailyCalcApplication() {
      const dc = this.dailyCalc || 100
      this.editContext.baseFee = Math.floor( Number(this.item.baseFee || this.usageRcPlan.baseFee || 0) * dc / 100  )
      this.changeUsageSubItems(dc)
    },

    /**
     * 총 청구액 계산
     */
    calcTotalFee() {
      this.editContext.sumAddFee = 0
      this.editContext.mpsUsageItems.forEach(e => {
        this.editContext.sumAddFee += Number(e.addFee || 0)
      })
      this.editContext.totalFee = this.editContext.baseFee + this.editContext.sumAddFee
    },

    /**
     * 초기화 버튼 클릭
     */
    onRefresh() {
      if(!confirm('초기화 하시겠습니까?'))
        return
      this.initData()
    },

    /**
     * 저장 버튼 클릭
     */
    onSaveUsage(){
      if(!confirm('저장 하시겠습니까?'))
        return
      this.isLoading = true
      this.$emit('save', this.editContext)
    },

    /**
     * 매출생성 버튼 클릭
     */
    onClickCreateBilling() {
      if(!confirm('저장 및 매출 생성 하시겠습니까?'))
        return
      this.isLoading = true
      this.$emit('create-billing', this.editContext)
    },
    onCloseThis(){
      if(!confirm('해당 창을 닫으시겠습니까?'))
        return
      this.isLoading = true
      this.$emit('close')
    },

    onChangeRcPlanId(e) {
      console.log('HSTEST::', e.target.value)
    }
  },
}
</script>

<style scoped>
.detail-dialog {
  background: #fff;
  padding: 12px;
  width: 100%;
  min-width: 1200px;
  max-width: 1200px;
}

.detail-dialog > div {
  padding: 4px 0;
}

.detail-dialog-header {
  display: flex;
  justify-content: space-between;
  border-bottom: 2px solid #dddddd;
}

.detail-dialog-header-title {
  font-size: 18px;
  font-weight: bold;
  text-align: left;
}

.detail-dialog-header-button {
  display: flex;
}

.detail-dialog-body {

}

.sub-container {
  display: flex;
  flex-direction: column;
  align-items: start;
}

.sub-title {
  font-size: 16px;
  text-align: left;
  font-weight: bold;
  color: #333333;
}

.sub-content-wrap {
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  padding: 0 32px;
}

.sub-content-item {
  display: flex;
  align-items: center;
  padding-right: 32px;
}

.sub-content-item.one-third {
  width: calc(100% / 3);
}

.sub-content-item.one-fourth {
  width: calc(100% / 4);
}

input,
select {
  flex: 1;
  margin-left: 16px;
  border-bottom: 1px solid #0c98fe;
  color: #1867c0;
  outline: none;
}

textarea {
  width: 100%;
  height: 100px;
  border: 1px solid #d0d0d0;
  resize: none;
}

spacer {
  width: 0;
  height: 0;
  margin: 4px;
}

table {
  width: 100%;
  border-spacing: 0;
  border-collapse: separate;
  border-left: 1px solid #d0d0d0;
  border-top: 1px solid #d0d0d0;
}

table thead tr th {
  background: #0c98fe;
  padding: 2px;
  color: white;
  border-right: 1px solid #d0d0d0;
  border-bottom: 1px solid #d0d0d0;
}

table tbody tr th {
  background: #f0f0f0;
  padding: 2px;
  color: black;
  font-weight: normal;
  text-align: right;
  border-right: 1px solid #d0d0d0;
  border-bottom: 1px solid #d0d0d0;
}

table tbody tr th.write-vertical-lr {
  writing-mode: vertical-lr;
  text-align: center;
}

table tbody tr:nth-child(2n) {
  background: #f4f4f4;
}

table tbody tr td {
  padding: 8px 4px;
  border-right: 1px solid #d0d0d0;
  border-bottom: 1px solid #d0d0d0;
}

.border-right-thick {
  border-right: 2px solid #666666;
}

table tbody tr td:nth-child(1) {
  text-align: right;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}
</style>